const onAnyPageMatch = () => {
  // RangeInput memorisation: lock icon next to .RangeInput, save/restore date range from localStorage
  if (typeof window.initRangeInputMemory === 'function') {
    window.initRangeInputMemory()
  }

  // Wrap .BackNavigationButton elements with anchor tags to redirect to /dashboard
  const wrapBackNavigationButtons = () => {
    const backButtons = document.querySelectorAll('.BackNavigationButton')
    backButtons.forEach(button => {
      // Check if already wrapped to avoid double-wrapping
      if (button.parentElement.tagName === 'A' && button.parentElement.href.includes('/dashboard')) {
        return
      }
      
      // Prevent the original onClick from triggering
      button.addEventListener('click', (event) => {
        event.preventDefault()
        event.stopPropagation()
        event.stopImmediatePropagation()
        // Navigate to dashboard instead
        window.location.href = '/dashboard'
      }, true) // Use capture phase to intercept before other handlers
      
      // Create anchor wrapper
      const anchor = document.createElement('a')
      anchor.href = '/dashboard'
      anchor.style.textDecoration = 'none'
      anchor.style.color = 'inherit'
      
      // Insert anchor before button and move button inside
      button.parentNode.insertBefore(anchor, button)
      anchor.appendChild(button)
    })
  }

  // Run immediately and also set up observer for dynamic content
  wrapBackNavigationButtons()
  
  // Set up observer to catch dynamically added back navigation buttons
  const observer = new MutationObserver(() => {
    wrapBackNavigationButtons()
  })
  
  // Only observe if document.body exists
  if (document.body) {
    observer.observe(document.body, {
      childList: true,
      subtree: true
    })
  } else {
    // Wait for body to be available
    const bodyObserver = new MutationObserver(() => {
      if (document.body) {
        observer.observe(document.body, {
          childList: true,
          subtree: true
        })
        bodyObserver.disconnect()
      }
    })
    bodyObserver.observe(document.documentElement, {
      childList: true,
      subtree: true
    })
  }

  const waitForPageLoad = setInterval(() => {
    const pageContent = document.querySelector('#page-header')
    if (pageContent && typeof isInRole === 'function') {
      const hasInvoiceButton = !!document.querySelector('#invoice-creation')

      // Both Impower navigation experiments retain #page-header, but the new
      // sidebar can mount it before the legacy header actions have rendered.
      // Keep polling for the clone and insertion targets instead of
      // dereferencing a temporarily missing QuickAddMenu.
      const headerContent = pageContent.querySelector('.header-content')
      const topQuickAdd = headerContent?.querySelector(
        '.header-item > .QuickAddMenu'
      )
      const topIconToCopy = topQuickAdd?.closest('.header-item')
      const headerSearch = headerContent?.querySelector(
        '.header-item.header-search'
      )
      const canInsertInvoiceButton = !!topIconToCopy && !!headerSearch

      if (hasInvoiceButton || canInsertInvoiceButton) {
        clearInterval(waitForPageLoad)
      }

      if (!hasInvoiceButton && canInsertInvoiceButton) {
        var newIcon = topIconToCopy.cloneNode(true)
        newIcon.id = 'invoice-creation'
        // Replace the contents of the span contained in the newIcon with an invoice creation icon
        newIcon.querySelector('span').innerHTML =
          '<svg fill="#000000" height="20px" width="20px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 310.75 310.75" xml:space="preserve"> <path d="M183.815,265.726c-32.444,0-60.868-21.837-76.306-54.325h102.101v-45.023H95.643c-0.284-3.642-0.437-7.29-0.437-11.016 	c0-3.691,0.152-7.384,0.437-10.977h113.969V99.353H107.51c15.438-32.485,43.861-54.315,76.306-54.315 	c31.01,0,60.21,20.759,76.2,54.152l40.626-19.418C277.091,30.554,232.329,0,183.815,0c-36.47,0-70.51,16.665-95.851,46.966 	C75.219,62.209,65.481,79.995,59.079,99.353H10.108v45.031h40.39c-0.217,3.617-0.329,7.311-0.329,10.977 	c0,3.704,0.112,7.351,0.329,11.016h-40.39V211.4h48.971c6.402,19.356,16.14,37.122,28.886,52.351 	c25.341,30.303,59.381,46.999,95.851,46.999c48.515,0,93.275-30.55,116.826-79.767l-40.626-19.454 	C244.025,244.965,214.825,265.726,183.815,265.726z"/> </svg>'
        newIcon.querySelector('span').style.position = 'relative'

        headerSearch.insertAdjacentElement('afterend', newIcon)

        newIcon.addEventListener('click', function (event) {
          event.preventDefault()
          event.stopPropagation()

          if (document.querySelector('#invoice-creation-overlay')) return

          var overlay = document.createElement('div')
          overlay.id = 'invoice-creation-overlay'
          overlay.style.position = 'fixed'
          overlay.style.inset = '0'
          overlay.style.backgroundColor = 'rgba(0, 0, 0, 0.8)'
          overlay.style.zIndex = '10000'
          overlay.style.display = 'flex'
          overlay.style.justifyContent = 'center'
          overlay.style.alignItems = 'center'

          var loadingContainer = document.createElement('div')
          loadingContainer.style.backgroundColor = 'white'
          loadingContainer.style.padding = '20px'
          loadingContainer.style.borderRadius = '8px'
          loadingContainer.style.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.1)'
          loadingContainer.style.display = 'flex'
          loadingContainer.style.flexDirection = 'column'
          loadingContainer.style.alignItems = 'center'

          var spinner = document.createElement('div')
          spinner.style.width = '40px'
          spinner.style.height = '40px'
          spinner.style.border = '4px solid rgba(0, 0, 0, 0.1)'
          spinner.style.borderRadius = '50%'
          spinner.style.borderTopColor = '#3498db'
          spinner.style.animation = 'invoiceCreationSpin 1s linear infinite'

          var style = document.createElement('style')
          style.textContent =
            '@keyframes invoiceCreationSpin { to { transform: rotate(360deg); } }'
          document.head.appendChild(style)

          var loadingText = document.createElement('div')
          loadingText.textContent = 'Laden...'
          loadingText.style.marginTop = '10px'
          loadingText.style.fontFamily = 'Arial, sans-serif'
          loadingText.style.fontSize = '16px'

          loadingContainer.appendChild(spinner)
          loadingContainer.appendChild(loadingText)
          overlay.appendChild(loadingContainer)
          document.body.appendChild(overlay)

          var iframe = document.createElement('iframe')
          iframe.src = `${baseApiUrl}/injects/invoice-creation/new`
          iframe.style.width = '100%'
          iframe.style.height = '100%'
          iframe.style.border = 'none'
          iframe.style.display = 'none'
          overlay.appendChild(iframe)

          iframe.onload = function () {
            loadingContainer.style.display = 'none'
            iframe.style.display = 'block'
            overlay.style.backgroundColor = 'transparent'
          }

          var closeInvoiceCreation = function (messageEvent) {
            if (
              messageEvent.source !== iframe.contentWindow ||
              messageEvent.data?.type !== 'CLOSE_INVOICE_CREATION_MODAL'
            ) {
              return
            }

            window.removeEventListener('message', closeInvoiceCreation)
            overlay.remove()
            style.remove()
          }

          window.addEventListener('message', closeInvoiceCreation)
        })
      }

      var openAIProofread = `<div style="display: inline-flex; align-items: center;"><svg viewBox="0 0 320 320" xmlns="http://www.w3.org/2000/svg" style="width: 16px; height: 16px; margin-right: 4px;"><path d="m297.06 130.97c7.26-21.79 4.76-45.66-6.85-65.48-17.46-30.4-52.56-46.04-86.84-38.68-15.25-17.18-37.16-26.95-60.13-26.81-35.04-.08-66.13 22.48-76.91 55.82-22.51 4.61-41.94 18.7-53.31 38.67-17.59 30.32-13.58 68.54 9.92 94.54-7.26 21.79-4.76 45.66 6.85 65.48 17.46 30.4 52.56 46.04 86.84 38.68 15.24 17.18 37.16 26.95 60.13 26.8 35.06.09 66.16-22.49 76.94-55.86 22.51-4.61 41.94-18.7 53.31-38.67 17.57-30.32 13.55-68.51-9.94-94.51zm-120.28 168.11c-14.03.02-27.62-4.89-38.39-13.88.49-.26 1.34-.73 1.89-1.07l63.72-36.8c3.26-1.85 5.26-5.32 5.24-9.07v-89.83l26.93 15.55c.29.14.48.42.52.74v74.39c-.04 33.08-26.83 59.9-59.91 59.97zm-128.84-55.03c-7.03-12.14-9.56-26.37-7.15-40.18.47.28 1.3.79 1.89 1.13l63.72 36.8c3.23 1.89 7.23 1.89 10.47 0l77.79-44.92v31.1c.02.32-.13.63-.38.83l-64.41 37.19c-28.69 16.52-65.33 6.7-81.92-21.95zm-16.77-139.09c7-12.16 18.05-21.46 31.21-26.29 0 .55-.03 1.52-.03 2.2v73.61c-.02 3.74 1.98 7.21 5.23 9.06l77.79 44.91-26.93 15.55c-.27.18-.61.21-.91.08l-64.42-37.22c-28.63-16.58-38.45-53.21-21.95-81.89zm221.26 51.49-77.79-44.92 26.93-15.54c.27-.18.61-.21.91-.08l64.42 37.19c28.68 16.57 38.51 53.26 21.94 81.94-7.01 12.14-18.05 21.44-31.2 26.28v-75.81c.03-3.74-1.96-7.2-5.2-9.06zm26.8-40.34c-.47-.29-1.3-.79-1.89-1.13l-63.72-36.8c-3.23-1.89-7.23-1.89-10.47 0l-77.79 44.92v-31.1c-.02-.32.13-.63.38-.83l64.41-37.16c28.69-16.55 65.37-6.7 81.91 22 6.99 12.12 9.52 26.31 7.15 40.1zm-168.51 55.43-26.94-15.55c-.29-.14-.48-.42-.52-.74v-74.39c.02-33.12 26.89-59.96 60.01-59.94 14.01 0 27.57 4.92 38.34 13.88-.49.26-1.33.73-1.89 1.07l-63.72 36.8c-3.26 1.85-5.26 5.31-5.24 9.06l-.04 89.79zm14.63-31.54 34.65-20.01 34.65 20v40.01l-34.65 20-34.65-20z"/></svg><span>Korrekturlesen</span></div>`
      var openAIAutocomplete = `<div style="display: inline-flex; align-items: center;"><svg viewBox="0 0 320 320" xmlns="http://www.w3.org/2000/svg" style="width: 16px; height: 16px; margin-right: 4px;"><path d="m297.06 130.97c7.26-21.79 4.76-45.66-6.85-65.48-17.46-30.4-52.56-46.04-86.84-38.68-15.25-17.18-37.16-26.95-60.13-26.81-35.04-.08-66.13 22.48-76.91 55.82-22.51 4.61-41.94 18.7-53.31 38.67-17.59 30.32-13.58 68.54 9.92 94.54-7.26 21.79-4.76 45.66 6.85 65.48 17.46 30.4 52.56 46.04 86.84 38.68 15.24 17.18 37.16 26.95 60.13 26.8 35.06.09 66.16-22.49 76.94-55.86 22.51-4.61 41.94-18.7 53.31-38.67 17.57-30.32 13.55-68.51-9.94-94.51zm-120.28 168.11c-14.03.02-27.62-4.89-38.39-13.88.49-.26 1.34-.73 1.89-1.07l63.72-36.8c3.26-1.85 5.26-5.32 5.24-9.07v-89.83l26.93 15.55c.29.14.48.42.52.74v74.39c-.04 33.08-26.83 59.9-59.91 59.97zm-128.84-55.03c-7.03-12.14-9.56-26.37-7.15-40.18.47.28 1.3.79 1.89 1.13l63.72 36.8c3.23 1.89 7.23 1.89 10.47 0l77.79-44.92v31.1c.02.32-.13.63-.38.83l-64.41 37.19c-28.69 16.52-65.33 6.7-81.92-21.95zm-16.77-139.09c7-12.16 18.05-21.46 31.21-26.29 0 .55-.03 1.52-.03 2.2v73.61c-.02 3.74 1.98 7.21 5.23 9.06l77.79 44.91-26.93 15.55c-.27.18-.61.21-.91.08l-64.42-37.22c-28.63-16.58-38.45-53.21-21.95-81.89zm221.26 51.49-77.79-44.92 26.93-15.54c.27-.18.61-.21.91-.08l64.42 37.19c28.68 16.57 38.51 53.26 21.94 81.94-7.01 12.14-18.05 21.44-31.2 26.28v-75.81c.03-3.74-1.96-7.2-5.2-9.06zm26.8-40.34c-.47-.29-1.3-.79-1.89-1.13l-63.72-36.8c-3.23-1.89-7.23-1.89-10.47 0l-77.79 44.92v-31.1c-.02-.32.13-.63.38-.83l64.41-37.16c28.69-16.55 65.37-6.7 81.91 22 6.99 12.12 9.52 26.31 7.15 40.1zm-168.51 55.43-26.94-15.55c-.29-.14-.48-.42-.52-.74v-74.39c.02-33.12 26.89-59.96 60.01-59.94 14.01 0 27.57 4.92 38.34 13.88-.49.26-1.33.73-1.89 1.07l-63.72 36.8c-3.26 1.85-5.26 5.31-5.24 9.06l-.04 89.79zm14.63-31.54 34.65-20.01 34.65 20v40.01l-34.65 20-34.65-20z"/></svg><span>Ausformulieren</span></div>`
      var joditContainers = document.querySelectorAll('.jodit-container')
      joditContainers.forEach(function (container) {
        // Find the UI group with the specified classes
        var uiGroup = container.querySelector(
          '.jodit-ui-group.jodit-ui-group_size_middle:not(.jodit-ui-group_line_true)'
        )
        if (uiGroup) {
          // Check if openAIProofread and openAIAutocomplete features are already injected
          var hasProofreadFeature = uiGroup.querySelector('[data-feature="openai-proofread"]')
          var hasAutocompleteFeature = uiGroup.querySelector('[data-feature="openai-autocomplete"]')
          
          if (hasProofreadFeature && hasAutocompleteFeature) {
            return // Skip if both features are already injected
          }

          // Remove disabled property from UI group and all its children
          const removeDisabled = (element) => {
            if (element.hasAttribute('disabled')) {
              element.removeAttribute('disabled')
            }
            Array.from(element.children).forEach((child) => {
              removeDisabled(child)
            })
          }
          removeDisabled(uiGroup)

          // Create and append a separator
          var separator = document.createElement('div')
          separator.className = 'jodit-ui-separator'
          uiGroup.appendChild(separator)

          // Find the last span element within the group
          var lastSpan = Array.from(uiGroup.children)
            .filter((child) => child.tagName === 'SPAN')
            .pop()
          if (lastSpan) {
            // Only inject proofread feature if not already present
            if (!hasProofreadFeature) {
              var clonedSpanProofread = lastSpan.cloneNode(true)
              var toolbarButtonText = clonedSpanProofread.querySelector(
                '.jodit-toolbar-button__text'
              )
              if (toolbarButtonText) {
                toolbarButtonText.innerHTML = openAIProofread
              }
              // Add data attribute to identify this feature
              clonedSpanProofread.setAttribute('data-feature', 'openai-proofread')
              uiGroup.appendChild(clonedSpanProofread)

              // Add click event listener for proofreading
              clonedSpanProofread.addEventListener('click', async () => {
                // Find the closest contenteditable div
                const editor = container.querySelector('[contenteditable="true"]')
                if (!editor) return

                // Get the text content
                const text = editor.innerHTML

                try {
                  // Send the text to the proofreading API
                  const response = await fetch(`${baseApiUrl}/api/ai/proofread`, {
                    method: 'POST',
                    headers: {
                      'Content-Type': 'application/json',
                      Authorization: `Bearer ${JSON.parse(localStorage.auth).token}`,
                    },
                    body: JSON.stringify({ text }),
                  })

                  if (!response.ok) {
                    throw new Error('Proofreading request failed')
                  }

                  const data = await response.json()

                  // Replace the editor content with the proofread text
                  editor.innerHTML = data.text
                } catch (error) {
                  console.error('Error during proofreading:', error)
                }
              })
            }

            // Only inject autocomplete feature if not already present
            if (!hasAutocompleteFeature) {
              var clonedSpanAutocomplete = lastSpan.cloneNode(true)
              var toolbarButtonText = clonedSpanAutocomplete.querySelector(
                '.jodit-toolbar-button__text'
              )
              if (toolbarButtonText) {
                toolbarButtonText.innerHTML = openAIAutocomplete
              }
              // Add data attribute to identify this feature
              clonedSpanAutocomplete.setAttribute('data-feature', 'openai-autocomplete')
              uiGroup.appendChild(clonedSpanAutocomplete)

              // Add click event listener for autocomplete
              clonedSpanAutocomplete.addEventListener('click', async () => {
                // Find the closest contenteditable div
                const editor = container.querySelector('[contenteditable="true"]')
                if (!editor) return

                // Get the text content
                const text = editor.textContent

                try {
                  // Send the text to the autocomplete API
                  const response = await fetch(
                    `${baseApiUrl}/api/ai/autocomplete`,
                    {
                      method: 'POST',
                      headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${JSON.parse(localStorage.auth).token}`,
                      },
                      body: JSON.stringify({ text }),
                    }
                  )

                  if (!response.ok) {
                    throw new Error('Autocomplete request failed')
                  }

                  const data = await response.json()

                  // Replace the editor content with the autocompleted text
                  editor.innerHTML = '<p>' + data.text + '</p>'
                } catch (error) {
                  console.error('Error during autocomplete:', error)
                }
              })
            }
          }
        }
      })
    }
  }, 100)
}

// Call the function
onAnyPageMatch()
